import React from 'react';

interface UploadProgressProps {
  progress: number; // 0 to 100
  fileName: string;
}

const UploadProgress: React.FC<UploadProgressProps> = ({ progress, fileName }) => {
  const containerStyle: React.CSSProperties = {
    padding: '1.5rem',
    marginTop: '1rem',
  };

  const barBackgroundStyle: React.CSSProperties = {
    height: '8px',
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderRadius: '4px',
    overflow: 'hidden',
    marginTop: '0.5rem',
  };

  const barFillStyle: React.CSSProperties = {
    height: '100%',
    width: `${progress}%`,
    background: 'linear-gradient(90deg, var(--gabmic-orange), #FFB266)',
    transition: 'width 0.3s ease',
  };

  return (
    <div className="premium-card" style={containerStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem' }}>
        <span>{fileName}</span>
        <span>{progress}%</span>
      </div>
      <div style={barBackgroundStyle}>
        <div style={barFillStyle}></div>
      </div>
    </div>
  );
};

export default UploadProgress;
